import { Button } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Rate, Segment } from '../../service/Experiments/Experiments';
import { RateEditor } from '../RateEditor/RateEditor';
import { ScopedPopup } from '../ScopedPopup/ScopedPopup';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import './ExSegmentRate.css';

interface ExSegmentRateProps {
    name: JSX.Element | string;
    segmentId: Segment['segment_id'];
    archived: boolean;
    rate?: Rate;
    onChange: (segmentId: Segment['segment_id'], data: Rate) => void;
}
interface ExSegmentRateState {
    isPopupOpen: boolean;
}

export class ExSegmentRate extends React.Component<ExSegmentRateProps, ExSegmentRateState> {
    public static defaultProps: Partial<ExSegmentRateProps> = {
        rate: {
            id: 0,
            value: undefined
        }
    };

    private rateValueButton: Button | null;

    constructor(props: ExSegmentRateProps) {
        super(props);

        this.state = {
            isPopupOpen: false
        };
    }

    render() {
        const { name, rate, archived } = this.props;

        return (
            <div
                className={Bem.cls('ex-segment-rate', '', {
                    archived: archived
                })}
            >
                {name}
                {this.getRatePreview(rate!.value || 0)}
                {this.getRatePopup()}
            </div>
        );
    }

    private getRatePreview = (value: number) => {
        const signType = value === 0 ? 'null' : value > 0 ? 'up' : 'down';

        return (
            <Button
                cls={Bem.cls('ex-segment-rate', 'value', { sign: signType })}
                size={'xs'}
                theme={'clear'}
                ref={i => (this.rateValueButton = i)}
                onClick={this.onRateValueClick}
            >
                <span className={Bem.cls('ex-segment-rate', 'value-number')}>{`${Math.abs(value)}%`}</span>
                <Shape2
                    cls={Bem.cls('ex-segment-rate', 'value-icon')}
                    width={12}
                    height={12}
                    icon={Shape2Icon.edit}
                    theme={Shape2Theme.light}
                />
            </Button>
        );
    };

    private getRatePopup = () => {
        const { isPopupOpen } = this.state;
        const { rate } = this.props;

        return (
            <ScopedPopup
                theme="normal"
                anchor={this.rateValueButton}
                visible={isPopupOpen}
                target="anchor"
                autoclosable={true}
                hasTail={true}
                onOutsideClick={this.closePopup}
                zIndexGroupLevel={8}
            >
                <RateEditor id={rate!.id} value={rate!.value} onSave={this.onSaveRate} onCancel={this.closePopup} />
            </ScopedPopup>
        );
    };

    private onRateValueClick = () => {
        this.setState({
            isPopupOpen: !this.state.isPopupOpen
        });
    };

    private closePopup = () => {
        this.setState({
            isPopupOpen: false
        });
    };

    private onSaveRate = (data: Rate) => {
        this.props.onChange(this.props.segmentId, data);
        this.setState({
            isPopupOpen: false
        });
    };
}
